import React, { forwardRef, useId } from 'react';
import { ChevronRightIcon } from '@heroicons/react/outline';
import { cn } from './cn';

/** Controlled inline detail row. Hidden content stays mounted to preserve editors. */
const DisclosureRow = forwardRef(function DisclosureRow({ title, titleContent, description, icon: Icon, badge, leading, variant = 'default', stackBadgeOnMobile = false, open, onToggle, children }, ref) {
  const id = useId();
  return (
    <div className={cn('border-b border-bun-line-soft last:border-b-0', leading && 'grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-3')}>
      {leading && <div>{leading}</div>}
      <button ref={ref} type="button" id={`${id}-trigger`} aria-label={title} aria-expanded={open} aria-controls={`${id}-content`} onClick={onToggle} className={cn('flex min-w-0 flex-1 w-full scroll-mt-20 items-center gap-3 border-0 bg-transparent px-1 text-left font-instrument hover:bg-bun-mist focus-visible:outline focus-visible:outline-2 focus-visible:outline-bun-blue', variant === 'compact' ? 'min-h-11 py-2 sm:min-h-8' : 'min-h-[72px] py-3')}>
        {Icon && <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-bun bg-bun-mist text-bun-slate"><Icon aria-hidden="true" className="h-[18px] w-[18px]" /></span>}
        <span className={cn('min-w-0 flex-1', stackBadgeOnMobile && 'flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3')}>
          <span className="min-w-0 flex-1">
          <span className="block text-bun-body font-semibold text-bun-text">{titleContent ?? title}</span>
          {description && <span className="mt-1 block truncate text-bun-meta font-book text-bun-stone">{description}</span>}
          </span>
          {stackBadgeOnMobile && badge}
        </span>
        {!stackBadgeOnMobile && badge}
        <ChevronRightIcon aria-hidden="true" className={cn('h-4 w-4 shrink-0 text-bun-stone', open && 'rotate-90')} />
      </button>
      <div id={`${id}-content`} role="region" aria-labelledby={`${id}-trigger`} hidden={!open} className={cn('space-y-3 pt-2 pb-4', leading && 'col-start-2')}>
        {children}
      </div>
    </div>
  );
});
export default DisclosureRow;
